import React, { Component } from 'react';
import { Select, Button, message } from 'antd';
import { Link } from 'react-router-dom';
import common_data from '../../api/common_data'
import {API_CONFIG} from '../../api/config.js'
import czyLogo from '../../imgs/czy_logo.svg'

const { Option } = Select
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  
    //滚动效果
    animateScroll = (element, speed) => {
      let rect = element.getBoundingClientRect();
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + rect.top-100;
      console.log(rect.top, top)
      let currentTop = 0;
      let requestId;
      //采用requestAnimationFrame，平滑动画
      function step(timestamp) {
          currentTop += speed;
          if (currentTop <= top) {
              window.scrollTo(0, currentTop);
              requestId = window.requestAnimationFrame(step);
          } else {
              window.cancelAnimationFrame(requestId);
          }
      }
      window.requestAnimationFrame(step);
  }

  render () {
    return (
      <div className='header-wrap'>
        <div className='logo_wrap'>
            <img src={czyLogo} alt=""/>
            <Select className='select_wrap' defaultValue={"zhCN"}>
              <Option value="zhCN">中文</Option>
              <Option value="enUS">English</Option> 
              {/* <Option value="zhCN_1">繁体中文</Option> */}
            </Select>
        </div>
        <ul className='nav_wrap'>
          <li
            onClick={() => {
              if(sessionStorage.getItem('company_token')) {
                window.open(`${API_CONFIG.yun_base}/?access_token=${sessionStorage.getItem('company_token') || ''}`);
              } else{
                message.error('请先登录账号')
              }
            }}
          >应用市场</li>
          <li
            onClick={() => {
              this.props.history.push({ pathname: '/solve_plan' })
            }}
          >物业解决方案</li>
          <li
            onClick={() => {
              if (this.props.history.location.pathname === '/') {
                this.animateScroll(common_data.refs.partner, 50)
            } else {
                this.props.history.push({ pathname: '/' })
                setTimeout(() => {
                    this.animateScroll(common_data.refs.partner, 50)
                }, 200)
            }
            }}
          >合作伙伴</li>
          <li
            onClick={() => {
              window.open("https://open-dev.colourlife.com/open_web/#/");
            }}
          >开放平台</li>
          {/* <li
            onClick={() => {
              this.props.history.push({ pathname: '' })
            }}
          >物业研究院</li> */}
        </ul>
        <div className='login_wrap'>
          <span 
            className='register_text'
            onClick={() => {
              this.props.history.push({ pathname: '/register' })
            }}
          >免费注册</span>
          <span 
            className='login-text'
            onClick={() => {
              this.props.history.push({ pathname: '/login' })
            }}
          >物业登录</span>
          <Button type="primary" ghost >
            体验演示版
          </Button>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/index/Header.jsx